module.exports = __webpack_public_path__ + "img/icon-04.a16af74f.png";